module.exports = __webpack_public_path__ + "static/media/htn.c61e6bf2.jpg";